export default "__VITE_ASSET__539a409c__"